document.addEventListener("DOMContentLoaded", function () {
  function waitForSwiper(callback) {
    if (typeof Swiper !== "undefined") {
      callback();
    } else {
      setTimeout(() => waitForSwiper(callback), 50);
    }
  }

  let swiper;
  const initSwiper = () => {
    if (swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }
    if (window.innerWidth < 768) {
      console.log("Initializing mobile swiper");
      swiper = new Swiper(".product-media__swiper", {
        slidesPerView: 1,
        spaceBetween: 1,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }
  };

  waitForSwiper(() => {
    initSwiper();
    window.addEventListener("resize", initSwiper);
  });

  updateVariantItem();
});

function updateVariantItem() {
  let variantsDataContent = document.querySelector("#product-variants-data");
  let data = JSON.parse(variantsDataContent.innerHTML);

  const hasColorOptions = document.querySelector(".product-swatches") || document.querySelector(".product-colors-table");
  const hasSizeOptions = document.querySelector(".product-sizes") || document.querySelector(".product-sizes-table");
  const hasVariantOptions = hasColorOptions || hasSizeOptions;

  const swatchSelected =
    document.querySelector(".product-swatches .custom-select-option.selected") ||
    document.querySelector(".product-colors-table .product-colors-table__cell.selected");
  const sizeSelected =
    document.querySelector(".product-sizes .custom-select-option.selected") ||
    document.querySelector(".product-sizes-table .product-sizes-table__cell.selected");

  const selectedColor = swatchSelected ? swatchSelected.dataset.value : null;
  const selectedSize = sizeSelected ? sizeSelected.dataset.value : null;

  // Determine option indices dynamically from product data
  const optionNames = data.option_names || [];
  const colorIndex = optionNames.findIndex((n) => n.toLowerCase() === "color");
  const sizeIndex = optionNames.findIndex((n) => n.toLowerCase() === "size");

  // Always mark availability regardless of whether a selection has been made
  if (colorIndex !== -1) {
    document.querySelectorAll(".product-swatches .custom-select-option").forEach((swatch) => {
      const swatchColor = swatch.dataset.value;
      const matchingVariant = data.variants.find((v) => {
        return (
          (selectedSize && sizeIndex !== -1 ? v.options[sizeIndex] === selectedSize : true) &&
          v.options[colorIndex] === swatchColor
        );
      });
      swatch.classList.toggle("stricked_out", !(matchingVariant && matchingVariant.available));
    });

    document.querySelectorAll(".product-colors-table .product-colors-table__cell").forEach((cell) => {
      const cellColor = cell.dataset.value;
      const matchingVariant = data.variants.find((v) => {
        return (
          (selectedSize && sizeIndex !== -1 ? v.options[sizeIndex] === selectedSize : true) &&
          v.options[colorIndex] === cellColor
        );
      });
      if (matchingVariant && matchingVariant.available) {
        cell.classList.remove("disabled");
        cell.setAttribute("aria-disabled", "false");
      } else {
        cell.classList.add("disabled");
        cell.setAttribute("aria-disabled", "true");
      }
    });
  }

  if (sizeIndex !== -1) {
    const sizeBtns = [
      ...document.querySelectorAll(".product-sizes .custom-select-option"),
      ...document.querySelectorAll(".product-sizes-table .product-sizes-table__cell"),
    ];
    sizeBtns.forEach((sizeBtn) => {
      const sizeValue = sizeBtn.dataset.value;
      const matchingVariant = data.variants.find((v) => {
        return (
          (selectedColor && colorIndex !== -1 ? v.options[colorIndex] === selectedColor : true) &&
          v.options[sizeIndex] === sizeValue
        );
      });
      if (matchingVariant && matchingVariant.available) {
        sizeBtn.classList.remove("disabled");
        sizeBtn.setAttribute("aria-disabled", "false");
      } else {
        sizeBtn.classList.add("disabled");
        sizeBtn.setAttribute("aria-disabled", "true");
      }
    });
  }

  let options = [];
  if (swatchSelected) options.push(selectedColor);
  if (sizeSelected) options.push(selectedSize);

  let addToCartBtn = document.getElementById("add-to-cart");
  let backInStockBtn = document.querySelector(".buy-button-back-in-stock");
  let deliveryTimeEl = document.getElementById("delivery-time");
  let deliveryTimeDataEl = document.querySelector("#delivery-time-data");
  let deliveryTimeData = deliveryTimeDataEl ? JSON.parse(deliveryTimeDataEl.innerHTML) : null;

  function setDeliveryTime(text) {
    if (!deliveryTimeEl) return;
    if (text) {
      deliveryTimeEl.textContent = "Estimated delivery: " + text;
      deliveryTimeEl.style.display = "";
    } else {
      deliveryTimeEl.style.display = "none";
    }
  }

  // Block if any available selector has no selection yet
  const colorRequired = !!hasColorOptions && !swatchSelected;
  const sizeRequired = !!hasSizeOptions && !sizeSelected;
  if (colorRequired || sizeRequired) {
    addToCartBtn.setAttribute("data-no-variant", "");
    addToCartBtn.classList.remove("button--hide");
    backInStockBtn.classList.add("button--hide");
    setDeliveryTime(null);
    return;
  }

  // Find matching variant (or use first for single-variant products)
  let variant = hasVariantOptions
    ? data.variants.find((v) => {
        if (selectedColor && !v.options.includes(selectedColor)) return false;
        if (selectedSize && !v.options.includes(selectedSize)) return false;
        return true;
      })
    : data.variants[0];

  if (!variant) return;

  addToCartBtn.removeAttribute("data-no-variant");

  let priceValue = document.querySelector(".product-details__price-value");
  let soldOutSpan = document.querySelector(".product-details__price-sold-out");
  let comparePrice = document.querySelector(".product-details__compare-price");

  if (priceValue) {
    const variantLabel = variant.options.filter((o) => o !== "Default Title").join(" / ");
    const priceText = variantLabel ? `${variant.price} (${variantLabel})` : variant.price;
    priceValue.textContent = priceText;
  }

  if (comparePrice) {
    comparePrice.textContent = variant.compare_at_price > variant.price ? variant.compare_at_price : "";
  }

  if (soldOutSpan) {
    soldOutSpan.style.display = variant.available ? "none" : "";
  }

  if (variant.available) {
    addToCartBtn.classList.remove("button--hide");
    backInStockBtn.classList.add("button--hide");
    addToCartBtn.dataset.variantId = variant.id;
    const btnPrice = document.querySelector(".product-buttons__price");
    if (btnPrice) btnPrice.textContent = variant.price;
    if (variant.inventory_quantity > 0) {
      setDeliveryTime(deliveryTimeData ? deliveryTimeData.in_stock : null);
    } else {
      setDeliveryTime(deliveryTimeData ? deliveryTimeData.out_of_stock : null);
    }
  } else {
    addToCartBtn.classList.add("button--hide");
    backInStockBtn.classList.remove("button--hide");
    backInStockBtn.dataset.variantId = variant.id;
    setDeliveryTime(null);
  }
}